// const baseUrl = "https://api.oicar.dev.br/api";
// const baseUrl = "http://localhost:8080/api";
const baseUrl = "https://api.oicar.com.br/api";

export default baseUrl;
